import { Tower } from '../api-types';
import { fetchAction } from '../../actions';
import CoreAPIService from '../../../utils/core-api';
import { paths } from '../../../routes/paths';
import { push } from 'connected-react-router';

export const name: string = 'towers';

// Action Types
export const types = {
    GET_TOWERS: 'GET_TOWERS',
    CREATE_TOWER: 'CREATE_TOWER',
    EDIT_TOWER: 'EDIT_TOWER',
    DELETE_TOWER: 'DELETE_TOWER',
};

interface TowerState {
    towers: Tower[];
}

// Initial State
const initialState: TowerState = {
    towers: [],
};

// Reducer
const reducer = (state = initialState, action: any): TowerState => {
    const { lat, lng } = action?.payload || {};
    switch (action.type) {
        case types.GET_TOWERS:
            return {
                ...state,
                towers: action.payload,
            };
        case types.CREATE_TOWER:
        case types.EDIT_TOWER:
        case types.DELETE_TOWER:
            return {
                ...state,
                towers: [],
            };
        default:
            return state;
    }
};
export default reducer;

// Actions
export const actions = {
    getTowers: () => fetchAction(CoreAPIService.get(`/core/control-tower`), types.GET_TOWERS, {}),
    createTower: (payload: Omit<Tower, 'Position' | 'id'>) =>
        fetchAction(
            CoreAPIService.post(`/core/control-tower`, payload),
            types.CREATE_TOWER,
            {},
            {
                success: (dispatch) => {
                    dispatch(push(`${paths.controlTowers}`));
                },
            },
        ),
    editTower: (id, payload: Omit<Tower, 'Position' | 'id'>) =>
        fetchAction(
            CoreAPIService.put(`/core/control-tower/${id}`, payload),
            types.EDIT_TOWER,
            { id },
            {
                success: (dispatch) => {
                    dispatch(push(`${paths.controlTowers}`));
                },
            },
        ),
    deleteTower: (id) =>
        fetchAction(
            CoreAPIService.delete(`/core/control-tower/${id}`),
            types.DELETE_TOWER,
            { id },
            {
                success: (dispatch) => {
                    dispatch(push(`${paths.controlTowers}`));
                },
            },
        ),
};

const localState = (state: any): TowerState => state[name] || initialState;
export const selectors = {
    towers: (state: TowerState) => localState(state).towers,
};
